import { Component, Input } from '@angular/core';
import { AuthService } from '../../../core/auth/auth.service'
import { CustomerService } from '../../../core/customer/customer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: 'sidebar.component.html'
})
export class SidebarComponent {
  constructor(public auth: AuthService, 
  private _customerService: CustomerService,
  private _router: Router) {

  }

  logout() {
    this.auth.logout().subscribe();
  }

  showProfile(){
    this._router.navigate(['juegos/management-profile']);
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/layouts/shared/sidebar/sidebar.component.ts